<template>
  <div class="page-container-202412051816">
    <div class="header-container">{{ $str.getKey('收益管理/电价历史') }}</div>
    <div class="main-container">
      <el-table :data="tableData" :border="false" v-loading="loading" stripe
        class="table-container fullfill-container hide-cell-border"
        :empty-text="getEmptyText()"
      >
        <el-table-column :label="$str.getKey('收益管理/电价名称')" prop="elecPriceName">
          <template #default="{ row }">
            <el-tooltip :content="row.elecPriceName" placement="top-start" :offset="4" :show-after="200">
              <span class="overflow-tooltip-cell">{{ row.elecPriceName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/开始日期')" prop="startDate" min-width="110"></el-table-column>
        <el-table-column :label="$str.getKey('收益管理/结束日期')" prop="endDate" min-width="110"></el-table-column>
        <el-table-column :label="$str.getKey('收益管理/创建人')" min-width="80" prop="creator">
          <template #default="{ row }">
            <el-tooltip :content="row.creator" placement="top-start" :offset="4" :show-after="200">
              <span class="overflow-tooltip-cell">{{ row.creator }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/创建时间')" min-width="110">
          <template #default="{ row }">
            <div class="time-format-cell">
              <div>{{row.createTime[0]}}</div>
              <div>{{row.createTime[1]}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/尖峰时段')" min-width="90">
          <template #default="{ row }">
            <div class="segment-price-cell">
              <span class="in"><span class="label-text">{{ $str.getKey('收益管理/充') }}</span> <span class="value-text">{{ row.inSharpPrice || 0 }}</span></span>
              <span class="out"><span class="label-text">{{ $str.getKey('收益管理/放') }}</span> <span class="value-text">{{ row.outSharpPrice || 0 }}</span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/高峰时段')" min-width="90">
          <template #default="{ row }">
            <div class="segment-price-cell">
              <span class="in"><span class="label-text">{{ $str.getKey('收益管理/充') }}</span> <span class="value-text">{{ row.inPeakPrice || 0 }}</span></span>
              <span class="out"><span class="label-text">{{ $str.getKey('收益管理/放') }}</span> <span class="value-text">{{ row.outPeakPrice || 0 }}</span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/平时段')" min-width="90">
          <template #default="{ row }">
            <div class="segment-price-cell">
              <span class="in"><span class="label-text">{{ $str.getKey('收益管理/充') }}</span> <span class="value-text">{{ row.inFlatPrice || 0 }}</span></span>
              <span class="out"><span class="label-text">{{ $str.getKey('收益管理/放') }}</span> <span class="value-text">{{ row.outFlatPrice || 0 }}</span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/低谷时段')" min-width="90">
          <template #default="{ row }">
            <div class="segment-price-cell">
              <span class="in"><span class="label-text">{{ $str.getKey('收益管理/充') }}</span> <span class="value-text">{{ row.inValleyPrice || 0 }}</span></span>
              <span class="out"><span class="label-text">{{ $str.getKey('收益管理/放') }}</span> <span class="value-text">{{ row.outValleyPrice || 0 }}</span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/深谷时段')" min-width="90">
          <template #default="{ row }">
            <div class="segment-price-cell">
              <span class="in"><span class="label-text">{{ $str.getKey('收益管理/充') }}</span> <span class="value-text">{{ row.inDeepValleyPrice || 0 }}</span></span>
              <span class="out"><span class="label-text">{{ $str.getKey('收益管理/放') }}</span> <span class="value-text">{{ row.outDeepValleyPrice || 0 }}</span></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/状态')" prop="status" min-width="70">
          <template #default="{ row }">
            <div class="status-cell" :style="{'--color':row.status.color}">
              <div class="status-lable" :status-type="row.status.type">{{row.status.name}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$str.getKey('收益管理/操作')" min-width="90">
          <template #default="{ row }">
            <div class="operate-cell">
              <el-button size="small" jd-type="reuse-text" link v-if="isShowOperateBtn(row.status.name, 4)" :disabled="!canReuseElectricPrice" @click="handleOperate(row.id, 4)">{{ $str.getKey('收益管理/启用') }}</el-button>
              <el-button size="small" jd-type="discard-text" link v-if="isShowOperateBtn(row.status.name, 5)" :disabled="!canDisableElectricPrice" @click="handleOperate(row.id, 5)">{{ $str.getKey('收益管理/弃用') }}</el-button>
              <el-button size="small" jd-type="reuse-text" link :disabled="!canReuseElectricPrice" @click="handleOperate(row.id, 6)">{{ $str.getKey('收益管理/复用') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-container" v-if="false">{{ $str.getKey('收益管理/分页') }}</div>
  </div>
</template>

<script setup>
import { ref, reactive, defineProps, defineEmits, inject, computed, watch } from "vue";
import { dayjs, ElMessageBox } from 'element-plus';
import { queryHistoryElecPriceList, operateElecPriceStatus } from "./api/index.js";
import { checkPermi } from '@/utils/permission';
import useAppStore from "@/store/modules/app";

const $str = window.$str;

const trackEvent = inject('trackEvent', () => {}); 
const trackEventTypes = inject('trackEventTypes', {
  edit: 'edit',
  otherOperate: 'otherOperate'
});
const trackDatas = reactive({
  startUseBtn: {
    targetId: '',
    refData: {
      targetName: '收益管理/启用按钮',
      desc: '启用当前电价'
    },
  },
  abandonBtn: {
    targetId: '',
    refData: {
      targetName: '收益管理/弃用按钮',
      desc: '弃用当前电价'
    },
  },
  reuseBtn: {
    targetId: '',
    refData: {
      targetName: '收益管理/复用按钮',
      desc: '以当前电价为基础，创建一条新电价'
    },
  },
})


defineExpose({ refreshHistoryList }); // 提供给父组件调用的方法
const emit = defineEmits(['refreshData', 'reCreate']); // 向父组件发送事件

const loading = ref(false); // 控制加载中动效的渲染
const appStore = useAppStore();
/** 获取stationId，并监听stationId的变化，触发刷新 */
const stationId = computed(() => appStore.stationId);
const canViewElectricPrice = computed(() => checkPermi(['operate:electricPrice:query']));
const canDisableElectricPrice = computed(() => checkPermi(['operate:electricPrice:disable']));
const canReuseElectricPrice = computed(() => checkPermi(['operate:electricPrice:reuse']));

// 监听 stationId 变化
watch(() => appStore.stationId, (newStationId) => {
  if (newStationId) {
    refreshHistoryList();
  }
}, { immediate: true })


const tableData = ref([]);

/** ====== [业务：功能方法] =================================================================== */

/** 操作：启用 | 弃用 */
async function handleOperate(id, type) {
  if ((type === 4 || type === 6) && !canReuseElectricPrice.value) return;
  if (type === 5 && !canDisableElectricPrice.value) return;
  if (type === 4 || type === 5) {
    const typeName = type === 4 ? $str.getKey('收益管理/启用') : $str.getKey('收益管理/弃用');

    const userAgree = await ElMessageBox.confirm($str.getKey('收益管理/是否') +' ' +typeName +' '+ $str.getKey('收益管理/该项电价？'), $str.getKey('收益管理/系统提示'), {
      confirmButtonText: $str.getKey('收益管理/确定'),
      cancelButtonText: $str.getKey('收益管理/取消'),
      "show-close": false,
      type: "warning"
    }).then(res => {
      return true;
    }).catch(err => {
      return false
    });
    if (userAgree) {
      operateElecPriceStatus(stationId.value, id, type).then(res => {
        // 埋点信息：
        if (type === 4) {
          trackDatas.startUseBtn.refData['stationId'] = stationId.value;
          trackDatas.startUseBtn.refData['elecPriceId'] = id;
          trackEvent(trackEventTypes.otherOperate, trackDatas.startUseBtn);
        }
        if (type === 5) {
          trackDatas.abandonBtn.refData['stationId'] = stationId.value;
          trackDatas.abandonBtn.refData['elecPriceId'] = id;
          trackEvent(trackEventTypes.otherOperate, trackDatas.abandonBtn);
        }

        // 操作成功，通知用户
        window.dispatchNotify({
          type: "success",
          message: typeName + ' ' +$str.getKey('收益管理/成功！')
        });
        // refreshHistoryList(); // 刷新列表
        emit("refreshData", {});
      }).catch(err => {
        window.dispatchNotify({
          type: "warning",
          message: typeName + ' ' +$str.getKey('收益管理/失败！')
        });  
        console.error(`电价${typeName}失败。电站ID ${stationId.value} 电价ID ${id}`);
      })
    }
  }
  // 基于当前电价重新创建
  if (type === 6) {
    const msgData = {
      elecPriceId: id,
      isCoverSelf: false,
    }
    emit('reCreate', msgData);
    
    // 埋点信息：
    trackDatas.reuseBtn.refData['stationId'] = stationId.value;
    trackDatas.reuseBtn.refData['elecPriceId'] = id;
    trackEvent(trackEventTypes.otherOperate, trackDatas.reuseBtn);
  }
}


/** 控制：操作按钮是否展示 */
function isShowOperateBtn(statusName, type) {
  // 启用按钮
  if (type === 4) {
    if (statusName === $str.getKey('收益管理/未使用')) {
      return true;
    } else {
      return false;
    }
  }
  // 弃用按钮
  if (type === 5) {
    if (statusName === $str.getKey('收益管理/已使用') || statusName === $str.getKey('收益管理/已弃用')) {
      return false;
    } else {
      return true;
    }
  }
}


/** ====== [辅助：功能方法] =================================================================== */
/** 刷新历史电价列表 */
function refreshHistoryList() {
  if (!canViewElectricPrice.value) {
    console.log('当前用户没有权限查看电价历史的数据');
    return false; // 当前用户没有权限查看电价历史的数据
  }
  queryHistoryElecPriceList(stationId.value).then(res => {
    if (Array.isArray(res?.data)) {
      const historyList = [];
      res.data.forEach(item => {
        const historyItem = {
          id: item.id,
          type: item.type, // 1基础电价 3自定义时段电价
          elecPriceName: item.priceName,
          startDate: item.startDate,
          endDate: item.endDate,
          creator: item.createBy,
          createTime: item.createTime ? item.createTime.split(' ') : '',
          redactor: item.updateBy,
          updateTime: item.updateTime,
          inSharpPrice: item.inSharpPrice,
          outSharpPrice: item.outSharpPrice,
          inPeakPrice: item.inPeakPrice,
          outPeakPrice: item.outPeakPrice,
          inFlatPrice: item.inFlatPrice,
          outFlatPrice: item.outFlatPrice,
          inValleyPrice: item.inValleyPrice,
          outValleyPrice: item.outValleyPrice,
          inDeepValleyPrice: item.inDeepValleyPrice,
          outDeepValleyPrice: item.outDeepValleyPrice,
          status: getElecPriceStatusInfo(item.status, item.id),
        }
        historyList.push(historyItem);
      });

      // tableData.value = sortHistoryList(historyList);
      tableData.value = historyList;
    }
  })
}

/** 历史列表排序 */
function sortHistoryList(originList) {
  originList.sort((a, b) => {
    const ta = dayjs(a.startDate);
    const tb = dayjs(b.startDate);
    if (ta.isBefore(tb)) {
      return 1;
    } else {
      return -1;
    }
  })
  
  const idx = originList.findIndex(it => it.status.type === 1);
  const inUseItems = originList.splice(idx,1);
  return [...inUseItems, ...originList];
}

/** 基于状态码获取状态信息 */
function getElecPriceStatusInfo(type, id) {
  let typeInfo = {
    type,
    name: '',
    color: '',
  }

  switch(type) {
    case 1:
      typeInfo.name = $str.getKey('收益管理/正在使用');
      typeInfo.color = '#00DD7A';
      break;
    case 2:
      typeInfo.name = $str.getKey('收益管理/预置电价');
      typeInfo.color = '#F09B3B';
      break;
    case 3:
      typeInfo.name = $str.getKey('收益管理/已使用');
      typeInfo.color = '#667084';
      break;
    case 4:
      typeInfo.name = $str.getKey('收益管理/未使用');
      typeInfo.color = '#98A2BB';
      break;
    case 5:
      typeInfo.name = $str.getKey('收益管理/已弃用');
      typeInfo.color = '#6C80FD';
      break;
    default:
      break;
  }

  if (!typeInfo.name) {
    if (id) {
      console.error(`id为${id}的电价历史，status为${type}，异常！请检查接口返回。`);
    } else {
      console.error(`电价历史数据status为${type}，异常！请检查接口返回。`);
    }
  } 

  return typeInfo;
}

/** 权限控制：表格空状态时展示的文字提示 */
function getEmptyText() {
  if (canViewElectricPrice.value) {
    return $str.getKey('收益管理/暂无数据');
  } else {
    return $str.getKey('收益管理/没有权限');
  }
}

</script>

<style lang="scss" scoped>
.page-container-202412051816 {
  --header-top: 40px;
  --footer-top: 50px;
  & {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 0 !important;
    align-items: stretch !important;
    align-self: stretch !important;
  }
  .header-container {
    width: 100%;
    height: auto;
    min-height: var(--header-top);
    color: #2E2E2E;
    font-family: "HarmonyOS Sans SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
    padding: 0;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .main-container {
    --min-height: 300px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    flex: 0 0 auto;
    min-height: var(--min-height);
    display: flex;
    flex-direction: column;
    background: transparent !important;
    padding: 0;
    margin: 0;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    overflow-x: auto;

    .table-container {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      flex: 0 0 auto;
      background: transparent !important;
      padding: 0;
      margin: 0;
      border: none !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      // 移除表格背景色，与主页面保持一致
      :deep(.el-table) {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
      }

      :deep(.el-table__header-wrapper) {
        background-color: transparent !important;
      }

      :deep(.el-table__body-wrapper) {
        background-color: transparent !important;
      }

      :deep(.el-table__header) {
        background-color: transparent !important;
      }

      :deep(.el-table__body) {
        background-color: transparent !important;
      }

      /* 表头样式 */
      :deep(.el-table th) {
        background-color: transparent !important;
        white-space: nowrap;
        padding: 6px 10px;
        line-height: 16px; /* 123.077% */
        font-size: 13px;
        color: #96A5B8;
        font-family: "HarmonyOS Sans SC";
        font-style: normal;
        font-weight: 400;
        text-align: left;

        .cell {
          color: #96A5B8;
          font-family: "HarmonyOS Sans SC";
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px; /* 123.077% */
          text-align: left;
        }
      }

      /* 表格内容样式 */
      :deep(.el-table td) {
        white-space: nowrap;
        padding: 6px 10px;
        line-height: normal;
        font-size: 14px;
        color: #444A6D;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: "HarmonyOS Sans SC";
        font-style: normal;
        font-weight: 400;
        text-align: left;
        background-color: transparent !important;

        .cell {
          color: #444A6D;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: "HarmonyOS Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-align: left;
        }
      }
      
      /* 确保表格行和条纹行背景透明 */
      :deep(.el-table__row) {
        background-color: transparent !important;
      }
      
      :deep(.el-table__row--striped) {
        background-color: transparent !important;
      }
      
      :deep(.el-table__row:hover) {
        background-color: transparent !important;
      }
      
      /* 关键列设置最小宽度，防止英文换行 */
      :deep(.el-table__cell[aria-colindex="6"]),
      :deep(.el-table__cell[aria-colindex="8"]) {
        min-width: 110px;
      }
      .overflow-tooltip-cell {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
      }

      .time-format-cell {
        display: flex;
        flex-direction: column;
        justify-content: center;
        // align-items: center;
      }
      .segment-price-cell {
        display: flex;
        flex-direction: column;
        
        .in {
          .label-text {
            color: #36B60C;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: "HarmonyOS Sans SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          .value-text {
            color: #444A6D;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: "HarmonyOS Sans SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
        
        .out {
          .label-text {
            color: #528DFF;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: "HarmonyOS Sans SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          .value-text {
            color: #444A6D;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: "HarmonyOS Sans SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
      }
      .status-cell {
        .status-lable {
          display: inline-block;
          font-feature-settings: 'liga' off, 'clig' off;
          font-family: "HarmonyOS Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          
          // 正在使用
          &[status-type="1"] {
            color: #36B60C;
          }
          
          // 已使用
          &[status-type="3"] {
            color: #96A5B8;
          }
        }
      }
      .operate-cell {
        display: flex;
        // width: 200px;

        // 操作列字体大小与状态列保持一致
        :deep(.el-button) {
          font-size: 14px !important;
        }

        // 复用按钮颜色与表格中充的颜色一致
        :deep(.el-button[jd-type="reuse-text"]) {
          color: #36B60C !important;

          &:hover {
            color: #36B60C !important;
          }

          span {
            color: #36B60C !important;
          }
        }
      }
    }
  }

  .footer-container {
    width: 100%;
    height: var(--footer-top);
    background: lawngreen;
  }

}

</style>
